import React from 'react'
import { SimpleForm, TextInput, SelectInput, BooleanInput, ReferenceInput, AutocompleteInput, NumberInput, DateTimeInput } from 'react-admin'
import { Box, Typography } from '@mui/material'
import { Edit as EditWrapper } from '../common/views'
import { leadStatusChoices, leadSourceChoices, leadDirectionChoices } from './constants'
import { industryChoices } from '../common/constants/industryChoices'

const LeadEdit = (props) => (
  <EditWrapper {...props}>
    <SimpleForm>
      {/* Lead Status */}
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <SelectInput
          source="status"
          label="Status"
          choices={leadStatusChoices}
          fullWidth
        />
        <SelectInput
          source="source"
          label="Source"
          choices={leadSourceChoices}
          fullWidth
        />
        <SelectInput
          source="direction"
          label="Direction"
          choices={leadDirectionChoices}
          fullWidth
        />
      </Box>

      {/* Contact Information */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 2 }}>
        Contact Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput
          source="first_name"
          label="First Name"
          fullWidth
          validate={(value) => (!value ? 'First name is required' : undefined)}
        />
        <TextInput
          source="last_name"
          label="Last Name"
          fullWidth
          validate={(value) => (!value ? 'Last name is required' : undefined)}
        />
        <TextInput
          source="email"
          label="Email"
          fullWidth
          type="email"
          validate={(value) => (!value ? 'Email is required' : undefined)}
        />
        <TextInput source="website" label="Website" fullWidth />
        <TextInput source="phone" label="Phone" fullWidth />
        <TextInput source="mobile" label="Mobile" fullWidth />
        <TextInput source="company" label="Company" fullWidth />
        <TextInput source="job_title" label="Job Title" fullWidth />
        <TextInput source="department" label="Department" fullWidth />
        <TextInput source="linkedin_url" label="LinkedIn Profile URL" fullWidth />
      </Box>

      {/* Lead Details */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Lead Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput source="campaign" label="Campaign" fullWidth />
        <ReferenceInput
          source="assigned_to_id"
          reference="users"
          label="Assigned To"
          fullWidth
        >
          <AutocompleteInput
            optionText="fullname"
            optionValue="id"
            shouldRenderSuggestions={(val) => true}
            emptyText="Select a user..."
            isLoading={false}
            filterToQuery={(searchText) => ({ q: searchText })}
          />
        </ReferenceInput>
        <SelectInput
          source="language"
          label="Language"
          choices={[
            { id: 'FR', name: 'French' },
            { id: 'EN', name: 'English' },
          ]}
          fullWidth
        />
        <SelectInput
          source="industry"
          label="Industry"
          choices={industryChoices}
          fullWidth
        />
        <BooleanInput source="marketing_consent" label="Marketing Consent" />
      </Box>

      {/* Project Information */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Project Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2, gridColumn: '1 / -1' }}>
        <TextInput
          source="project_description"
          label="Project Description (What)"
          multiline
          fullWidth
          rows="3"
        />
        <TextInput
          source="project_reason"
          label="Project Reason (Why)"
          multiline
          fullWidth
          rows="3"
        />
        <TextInput
          source="project_location"
          label="Project Location (Where)"
          fullWidth
        />
        <TextInput
          source="project_timeline"
          label="Project Timeline (When)"
          multiline
          fullWidth
          rows="2"
        />
        <TextInput
          source="project_budget"
          label="Project Budget"
          multiline
          fullWidth
          rows="2"
        />
      </Box>

      {/* Financial */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Financial
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <NumberInput source="expected_revenue" label="Expected Revenue" fullWidth />
        <NumberInput source="proposal_amount" label="Proposal Amount" fullWidth />
      </Box>

      {/* Key Dates */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Key Dates
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <DateTimeInput source="meeting_scheduled_date" label="Meeting Scheduled Date" fullWidth />
      </Box>

      {/* Conversion Links (Read-only info) */}
      <Typography variant="h6" sx={{ gridColumn: '1 / -1', mt: 3 }}>
        Conversion
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, gridColumn: '1 / -1' }}>
        <ReferenceInput source="customer_id" reference="customers" label="Customer">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
      </Box>
    </SimpleForm>
  </EditWrapper>
)

export default LeadEdit
